/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type LeagueStatsDisplayQueryVariables = {|
  seasonID?: ?string
|};
export type LeagueStatsDisplayQueryResponse = {|
  +nflScoutingReportTeamStats: ?$ReadOnlyArray<?{|
    +team: ?{|
      +id: string,
      +abbreviation: string,
    |},
    +playsPerGame: ?number,
    +yardsPerPlay: ?number,
    +passYdsPerAtt: ?number,
    +rushYdsPerAtt: ?number,
    +oppYardsPerPlay: ?number,
    +oppPassYdsPerAtt: ?number,
    +oppRushYdsPerAtt: ?number,
  |}>
|};
export type LeagueStatsDisplayQuery = {|
  variables: LeagueStatsDisplayQueryVariables,
  response: LeagueStatsDisplayQueryResponse,
|};
*/


/*
query LeagueStatsDisplayQuery(
  $seasonID: ID
) {
  nflScoutingReportTeamStats(seasonId: $seasonID) {
    team {
      id
      abbreviation
    }
    playsPerGame
    yardsPerPlay
    passYdsPerAtt
    rushYdsPerAtt
    oppYardsPerPlay
    oppPassYdsPerAtt
    oppRushYdsPerAtt
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "seasonID"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "seasonId",
        "variableName": "seasonID"
      }
    ],
    "concreteType": "NFLScoutingReportTeamStatType",
    "kind": "LinkedField",
    "name": "nflScoutingReportTeamStats",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NFLStatTeamType",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "abbreviation",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "playsPerGame",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "yardsPerPlay",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "passYdsPerAtt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rushYdsPerAtt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "oppYardsPerPlay",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "oppPassYdsPerAtt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "oppRushYdsPerAtt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LeagueStatsDisplayQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LeagueStatsDisplayQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a175a5dfe67d1173491e8ac3735b09fd",
    "id": null,
    "metadata": {},
    "name": "LeagueStatsDisplayQuery",
    "operationKind": "query",
    "text": "query LeagueStatsDisplayQuery(\n  $seasonID: ID\n) {\n  nflScoutingReportTeamStats(seasonId: $seasonID) {\n    team {\n      id\n      abbreviation\n    }\n    playsPerGame\n    yardsPerPlay\n    passYdsPerAtt\n    rushYdsPerAtt\n    oppYardsPerPlay\n    oppPassYdsPerAtt\n    oppRushYdsPerAtt\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a0bc7e66099c2e08ae17f84dc7b288c8';

module.exports = node;
